import { HttpErrorResponse, HttpHandler, HttpRequest } from '@angular/common/http';
import { Injector } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigService } from '@core/shared/config';
import { dayjs } from '@core/shared/utils/dayjs';
import { Store } from '@ngxs/store';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ErrorHandlerService } from '../../error/error-handler/error-handler.service';
import { FeatureRouterLinkResolverService } from '../../feature/router-link-resolver/feature-router-link-resolver.service'; // deep to fix circular dependency!
import { I18nState } from '../../i18n';
import { AccessFacade } from '../access/access.facade';
import { AccessState } from '../access/access.state';
import * as i0 from "@angular/core";
import * as i1 from "@core/shared/config";
import * as i2 from "@angular/router";
import * as i3 from "../access/access.facade";
import * as i4 from "@ngxs/store";
const LOCAL_TIME_HEADER = 'x-local-time';
// token sources from State + BaseAccessService are problematic. 
// When getting ttoken from LocalStorage it will be available in Store early, but only later in TokenSerivce.
// But after logging in, it will first be available in BaseAccessService and not synchronously in Store.
export let SessionIdInterceptor = /*#__PURE__*/(() => {
  class SessionIdInterceptor {
    constructor(
    // private messages:AppMessageFactory,
    // private route:ActivatedRoute,
    config, router, access, store, injector) {
      this.router = router;
      this.access = access;
      this.store = store;
      this.injector = injector;
      this.forcedLanguage = null;
      this.defaultLanguage = null;
      this.forcedLanguage = config.get('i18n.forcedLanguage', null);
      this.defaultLanguage = config.get('i18n.defaultLanguage', 'de');
    }
    intercept(request, next) {
      const newHeaders = {};
      this.setLocalTimeHeader(newHeaders);
      this.setAuthorizationHeader(newHeaders);
      this.setLanguageHeader(newHeaders);
      request = request.clone({
        setHeaders: newHeaders,
        withCredentials: true // send cookies
      });
      return next.handle(request).pipe(catchError((err, caught) => {
        // unauthorized. Auto log out!
        if (err.status === 401) {
          // console.log('@TODO auto log out here?')
          // if(!isTryingToLogin()) {
          const routerLinkResolver = this.injector.get(FeatureRouterLinkResolverService);
          this.access.logout();
          this.router.navigate(routerLinkResolver.resolveRouterLink('login'));
          // }
        }
        return throwError(() => err);
      }));
    }
    /**
     * Handling of local time is tricky, beacuse Date object does not fully support timezones.
     * It can only support UTC and the platform time zone.
     * To work around this, we here use dayjs to immediately export as a easily parseable string.
     * timeHeader uses special format "YYYY-MM-DD HH:mm:ss ZZ (Zone)"
     */
    setLocalTimeHeader(newHeaders) {
      const timezoneInfo = Intl.DateTimeFormat().resolvedOptions().timeZone;
      if (timezoneInfo === 'PST8PDT') {
        this.injector.get(ErrorHandlerService).logInfo('Browser uses PST8PDT');
      }
      const localTime = dayjs().format('YYYY-MM-DD HH:mm:ss ZZ') + ` (${timezoneInfo})`;
      newHeaders[LOCAL_TIME_HEADER] = localTime;
    }
    // add authorization header with sessionId if available
    setAuthorizationHeader(newHeaders) {
      const sessionId = this.store.selectSnapshot(AccessState.sessionId);
      if (sessionId) {
        newHeaders.Authorization = `Bearer ${sessionId}`;
      }
    }
    setLanguageHeader(newHeaders) {
      // in case of forcedLanguage, there is no "choice" an acceptable languages and we just skip the header.
      if (this.forcedLanguage) return;
      const activeLanguage = this.store.selectSnapshot(I18nState.calculatedLanguage);
      // must only be assigned if activeLanguage is set! will result in errors due to nullish HttpHeader entry otherwise!
      if (activeLanguage) {
        newHeaders['Accept-Language'] = activeLanguage;
      }
    }
    static {
      this.ɵfac = function SessionIdInterceptor_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SessionIdInterceptor)(i0.ɵɵinject(i1.ConfigService), i0.ɵɵinject(i2.Router), i0.ɵɵinject(i3.AccessFacade), i0.ɵɵinject(i4.Store), i0.ɵɵinject(i0.Injector));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: SessionIdInterceptor,
        factory: SessionIdInterceptor.ɵfac
      });
    }
  }
  return SessionIdInterceptor;
})();